var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ipaam-logo"},[_c('img',{attrs:{"src":require("@/assets/logo-ipaam-carteira.png"),"alt":"Logo IPAAM"}}),_c('p',[_vm._v("Instituto de Proteção Ambiental do Amazonas"),_c('br'),_vm._v("IPAAM")])])
}]

export { render, staticRenderFns }